import { observer, inject } from 'mobx-react'
import React, { Component } from 'react'
import { Form, Button } from 'react-bootstrap'
import t from '../../service/translate.service'
import PrimaryTitle from '../../components/PrimaryTitle'
import ThankYouOverlay from '../../components/ThankYouOverlay'
import { Textarea } from '../../components/formComponents'
import faqCategoryStore from '../../store/admin/FaqCategory.store'
import User from '../../store/user.store'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import historyService from '../../service/history.service'
import { Alert } from 'antd'
import { autorun, extendObservable } from 'mobx'

class FaqCategories extends Component {
  static propTypes = {
    faqFeedbackStore: PropTypes.object.isRequired
  }
  constructor (props) {
    super(props)

    const includeFaqQuestions = true
    this.inputRefs = [
      React.createRef()
    ]
    extendObservable(this, {
      submitted: false,
      errorsList: [],
      errorListVoice: false
    })
    autorun(() => {
      this.props.faqFeedbackStore.resetForm()
    })
    faqCategoryStore.getAll(includeFaqQuestions)
  }

  submitFeedback = (e) => {
    this.submitted = false
    setTimeout(() => {
      this.errorsList = this.generateErrorList()
      this.errorListVoice = true
      this.submitted = true
    }, 100)
    this.props.faqFeedbackStore.error = false
    e.preventDefault()
    this.props.faqFeedbackStore.submit()
  }
  handleBack = () => {
    this.props.faqFeedbackStore.resetForm()
  }

  getAttrs = field => {
    const { model, setVal, validators, alertValidators } = this.props.faqFeedbackStore
    return {
      value: model[field],
      onChange: e => {
        this.errorListVoice = false
        setVal(field, e.target.value)
      },
      validate: validators[field],
      blurValidate: alertValidators[field]
    }
  }

  generateErrorList = () => {
    const errors = []
    for (let i = 0; i < this.inputRefs.length; i++) {
      const inputRef = this?.inputRefs[i]?.current
      if (i === 0) {
        const val = inputRef?.value
        const label = inputRef?.ariaLabel
        const error = this.props.faqFeedbackStore.alertValidators['feedback'](val, label)
        if (error) {
          errors.push(
            <button
              key={1}
              type='button'
              onClick={() => {
                inputRef.focus()
              }}
            >
              {error}
            </button>
          )
        }
      }
    }
    return errors
  }

  AlertContent = () => {
    const errorsList = this.errorsList
    const errorListVoice = this.errorListVoice
    if (errorsList?.length > 0) {
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  render () {
    return (
      <div>
        {this.props.faqFeedbackStore.showThankYouPage ? (
          <ThankYouOverlay
            title={t.THANK_YOU}
            description={t.FEEDBACK_THANK_YOU}
            buttonText={t.BACK_TO_FAQ}
            buttonLink='/faq'
            handleClick={this.handleBack}
          />
        ) : (
          <div className='faq-categories'>
            <PrimaryTitle title={t.MAIN_FAQ} />
            <div className='no-content'>
              <div className='message' style={{ fontWeight: 'bold' }}>
                {t.MAIN_FAQ_TEXT}
              </div>
            </div>
            {(!faqCategoryStore.loading || faqCategoryStore.faqCategories.length) &&
              faqCategoryStore.faqCategories.map(category => {
                const guestQuestions = category?.faqQuestions?.filter(
                  question => !question.hideForGuest
                );
                const registerQuestions = category?.faqQuestions?.map(
                  question => question
                );
                if (
                  (guestQuestions?.length > 0 && !User.user) ||
                  (registerQuestions?.length > 0 && User.user)
                ) {
                  return (
                    <Link
                      key={category.id}
                      className='button primary'
                      style={{
                        marginTop: 32,
                        paddingHorizontal: 24,
                      }}
                      to={`/faq/${category.id}`}
                      onClick={() => historyService.push(`/faq/${category.id}`)}
                      aria-label={localStorage.getItem('locale') === 'de' ? category.nameDe : category.name}
                    >
                      {localStorage.getItem('locale') === 'de'
                        ? category.nameDe
                        : category.name}
                    </Link>
                  );
                }
              })}
            <div className='faq-form' ref={el => { this.feedbackRef = el }}>
              <div className='faq-form-title'>{t.MAIN_FAQ_FEEDBACK_TEXT}</div>
              <Form>
                {this.submitted && (
                  <this.AlertContent />
                )}
                <Textarea
                  ref={this.inputRefs[0]}
                  {...this.getAttrs('feedback')}
                  name='feedback'
                  label='Feedback'
                  aria-label={t.MAIN_FAQ_FEEDBACK_TEXT}
                  required={true}
                />
    
                <Form.Group className='text-center'>
                  {this.props.faqFeedbackStore.error && <Alert message={this.props.faqFeedbackStore.errorMsg} type='error' style={{marginTop: '12px', marginBottom: '12px'}} aria-live="assertive" role='alert' />}
                  <button
                    type='submit'
                    className='button primary'
                    onClick={this.submitFeedback}
                    aria-label={t.MAIN_FAQ_SUBMIT}
                  >
                    {t.MAIN_FAQ_SUBMIT}
                  </button>
                </Form.Group>
              </Form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default inject('faqFeedbackStore')(observer(FaqCategories))
